import { render, staticRenderFns } from "./RelatorioLeiloesNegativosWindow.vue?vue&type=template&id=5215323f"
import script from "./RelatorioLeiloesNegativosWindow.vue?vue&type=script&lang=js"
export * from "./RelatorioLeiloesNegativosWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports